"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _upperFirst = _interopRequireDefault(require("lodash/upperFirst"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotion = require("emotion");

var _tile = _interopRequireDefault(require("@amzn/meridian-tokens/component/tile"));

var _tileContext = _interopRequireDefault(require("./tile-context"));

var _clickable = _interopRequireDefault(require("../_clickable"));

var _theme = require("../theme");

var _useFocus2 = _interopRequireDefault(require("../_use-focus"));

var _propTypes2 = _interopRequireDefault(require("./../_prop-types"));

var _parsers = require("./../_prop-types/parsers");

var _text = _interopRequireDefault(require("./../_styles/text"));

var _focusRing = _interopRequireDefault(require("./../_styles/focus-ring"));

var _token = require("./../_utils/token");

var _focus = require("./../_utils/focus");

var _rtl = require("./../_utils/rtl");

var _functional = require("./../_utils/functional");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// Returns an array of border radii css selectors for a particular side
var getBorderRadii = function getBorderRadii(side) {
  return {
    left: ["borderTopLeftRadius", "borderBottomLeftRadius"],
    top: ["borderTopLeftRadius", "borderTopRightRadius"],
    right: ["borderTopRightRadius", "borderBottomRightRadius"],
    bottom: ["borderBottomLeftRadius", "borderBottomRightRadius"]
  }[side];
};

var getAccentPosition = function getAccentPosition(_ref) {
  var side = _ref.side,
      borderWidth = _ref.borderWidth,
      accentWidth = _ref.accentWidth;
  return {
    right: {
      top: -borderWidth,
      right: -borderWidth,
      bottom: -borderWidth,
      width: accentWidth
    },
    left: {
      top: -borderWidth,
      left: -borderWidth,
      bottom: -borderWidth,
      width: accentWidth
    },
    top: {
      top: -borderWidth,
      left: -borderWidth,
      right: -borderWidth,
      height: accentWidth
    }
  }[side];
}; // "Clips" an element's side by setting that side's border width and
// corner radii to 0. If the side has an rtl corollary then a dir="rtl" rule
// will also be added.


var clipTile = (0, _functional.memoize)(function (side) {
  return _objectSpread((0, _defineProperty2["default"])({}, "border".concat((0, _upperFirst["default"])(side), "Width"), "0"), getBorderRadii(side).reduce(function (radiiStyles, radius) {
    radiiStyles[radius] = 0;
    return radiiStyles;
  }, {}));
}); // "Clips" an accent

var clipAccent = (0, _functional.memoizeByKeys)(function (_ref2) {
  var accentSide = _ref2.accentSide,
      clipLeft = _ref2.clipLeft,
      clipRight = _ref2.clipRight,
      clipTop = _ref2.clipTop,
      clipBottom = _ref2.clipBottom,
      borderRadius = _ref2.borderRadius;
  var accentSideRtl = (0, _rtl.getRtl)(accentSide) || "top";
  var ltrStyle = getBorderRadii(accentSide).reduce(function (radiiStyles, radius) {
    radiiStyles[radius] = clipLeft && radius.includes("Left") || clipTop && radius.includes("Top") || clipBottom && radius.includes("Bottom") || clipRight && radius.includes("Right") ? 0 : borderRadius;
    return radiiStyles;
  }, {});
  var rtlStyle = getBorderRadii(accentSideRtl).reduce(function (radiiStyles, radius) {
    radiiStyles[radius] = clipLeft && radius.includes("Right") || clipRight && radius.includes("Left") || clipTop && radius.includes("Top") || clipBottom && radius.includes("Bottom") ? 0 : borderRadius;
    return radiiStyles;
  }, {});
  return _objectSpread(_objectSpread({}, ltrStyle), {}, (0, _defineProperty2["default"])({}, '[dir="rtl"] &', _objectSpread({
    borderRadius: 0
  }, rtlStyle)));
}, ["accentSide", "clipLeft", "clipRight", "clipTop", "clipBottom", "borderRadius"]);
var styles = (0, _token.memoizeTokenStyles)(function (t, _ref3) {
  var _objectSpread5, _objectSpread6;

  var accent = _ref3.accent,
      accentPosition = _ref3.accentPosition,
      clickable = _ref3.clickable,
      pressed = _ref3.pressed,
      disabled = _ref3.disabled,
      focus = _ref3.focus,
      spacingInset = _ref3.spacingInset,
      _ref3$layout = _ref3.layout,
      layout = _ref3$layout === void 0 ? {} : _ref3$layout,
      clipStart = _ref3.clipStart,
      clipLeft = _ref3.clipLeft,
      clipEnd = _ref3.clipEnd,
      clipRight = _ref3.clipRight,
      clipTop = _ref3.clipTop,
      clipBottom = _ref3.clipBottom;
  var borderWidth = t("borderWidth");
  var borderColor = t("borderColor");
  var borderRadius = t("borderRadius");
  var accentWidth = t("accentWidth");
  var accentSide = accentPosition === "start" ? "left" : accentPosition === "end" ? "right" : accentPosition;
  var accentSideRtl = accentSide === "left" ? "right" : accentSide === "right" ? "left" : undefined;
  return (0, _emotion.css)((0, _text["default"])(t, {
    color: disabled ? "disabled" : "default"
  }),
  /**
   * Focus styles
   */
  clickable && !disabled && (0, _focusRing["default"])(t.tokens, {
    focus: focus,
    offset: 4,
    borderRadius: borderRadius,
    borderWidth: borderWidth,
    dropShadow: t.boxShadowCss("dropShadowHover"),
    hoverSelector: "&:hover, &[mdn-tile-hover]"
  }), _objectSpread(_objectSpread({}, layout), {}, (_objectSpread6 = {
    backgroundColor: t("backgroundColor"),
    // If we received top/left values for the layout then absolutely
    // position the tile, otherwise position it relatively (either way we
    // need something other than static positioning so that the absolutely
    // positioned accent bar works).
    position: layout.top === undefined && layout.left === undefined ? "relative" : "absolute",
    borderStyle: "solid",
    borderWidth: borderWidth,
    borderRadius: borderRadius,
    borderColor: borderColor,
    transition: "transform 0.1s ease, box-shadow 0.1s ease"
  }, (0, _defineProperty2["default"])(_objectSpread6, accentPosition === "left" || accentPosition === "start" ? "paddingLeft" : accentPosition === "right" || accentPosition === "end" ? "paddingRight" : "paddingTop", accent ? accentWidth + borderWidth : undefined), (0, _defineProperty2["default"])(_objectSpread6, '[dir="rtl"] &', (0, _defineProperty2["default"])({
    padding: 0
  }, accentPosition === "left" || accentPosition === "start" ? "paddingRight" : accentPosition === "right" || accentPosition === "end" ? "paddingLeft" : "paddingTop", accent ? accentWidth + borderWidth : undefined)), (0, _defineProperty2["default"])(_objectSpread6, "& > [mdn-tile-children]", {
    padding: spacingInset ? (0, _parsers.parseSpacing)(spacingInset).map(function (value) {
      return "".concat(value, "px");
    }).join(" ") : t("spacingInset")
  }), (0, _defineProperty2["default"])(_objectSpread6, "* > &", clickable && !disabled ? {
    boxShadow: t.boxShadowCss("dropShadowDefault"),
    transform: "translateY(".concat(t("offsetVerticalDefault"), "px)")
  } : undefined), (0, _defineProperty2["default"])(_objectSpread6, "*:hover > &, [mdn-tile-hover] > &", clickable && !disabled ? {
    boxShadow: t.boxShadowCss(pressed ? "dropShadowPressed" : "dropShadowHover"),
    transform: "translateY(".concat(t(pressed ? "offsetVerticalPressed" : "offsetVerticalHover"), "px)")
  } : undefined), (0, _defineProperty2["default"])(_objectSpread6, "&:before", accent ? (0, _emotion.css)(_objectSpread(_objectSpread({
    content: "\"\"",
    boxSizing: "content-box",
    position: "absolute",
    backgroundColor: accent
  }, getAccentPosition({
    side: accentSide,
    borderWidth: borderWidth,
    accentWidth: accentWidth
  })), {}, (_objectSpread5 = {}, (0, _defineProperty2["default"])(_objectSpread5, '[dir="rtl"] &', accentSideRtl ? _objectSpread(_objectSpread({}, getAccentPosition({
    side: accentSideRtl,
    borderWidth: borderWidth,
    accentWidth: accentWidth
  })), {}, (0, _defineProperty2["default"])({}, accentSide, "unset")) : undefined), (0, _defineProperty2["default"])(_objectSpread5, "border", "inherit"), _objectSpread5)), clipAccent({
    accentSide: accentSide,
    clipLeft: clipLeft || clipStart,
    clipRight: clipRight || clipEnd,
    clipTop: clipTop,
    clipBottom: clipBottom,
    borderRadius: borderRadius
  })) : undefined), _objectSpread6)), clipRight || clipEnd ? clipTile("right") : null, clipLeft || clipStart ? clipTile("left") : null, clipBottom ? clipTile("bottom") : null, clipTop ? clipTile("top") : null, (0, _defineProperty2["default"])({}, '[dir="rtl"] &', (0, _emotion.css)({
    borderWidth: borderWidth,
    borderRadius: borderRadius
  }, clipRight || clipEnd ? clipTile("left") : null, clipLeft || clipStart ? clipTile("right") : null, clipBottom ? clipTile("bottom") : null, clipTop ? clipTile("top") : null)));
}, ["accent", "accentPosition", "disabled", "focus", "spacingInset", "pressed", "clickable", "layout", "clipStart", "clipEnd", "clipRight", "clipLeft", "clipBottom", "clipTop"]);
/**
 * This component renders a tile. The primary use-cases for this component are to
 * render dashboard tiles for data visualization and event tiles for calendars.
 *
 * @since 5.x
 */

var Tile = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var t = (0, _theme.useTheme)(_tile["default"], "tile");

  var _useFocus = (0, _useFocus2["default"])(),
      focus = _useFocus.focus,
      focusTrigger = _useFocus.focusTrigger,
      focusDescendent = _useFocus.focusDescendent,
      focusProps = _useFocus.focusProps;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      pressed = _useState2[0],
      setPressed = _useState2[1];

  var clickable = props.onClick || props.href; // Manage state for the overflow menu up here so we can fix the tile's hover
  // state when the menu is open.

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      actionMenuOpen = _useState4[0],
      setActionMenuOpen = _useState4[1];

  var accentPosition = props.accentPosition,
      disabled = props.disabled;
  var context = (0, _react.useMemo)(function () {
    return {
      t: t,
      accentPosition: accentPosition,
      actionMenuOpen: actionMenuOpen,
      setActionMenuOpen: setActionMenuOpen,
      disabled: disabled
    };
  }, [t, accentPosition, actionMenuOpen, disabled]);
  var accent = (0, _react.useMemo)(function () {
    return props.accent ? t("accentColor", disabled ? "disabled" : props.accent) || props.accent : undefined;
  }, [t, props.accent, disabled]); // Render the tile element. We will either return this directly or wrap it
  // in a Clickable based on the props provided to us.

  var tileElement = /*#__PURE__*/_react["default"].createElement("div", {
    className: styles(t, {
      clickable: clickable,
      disabled: disabled,
      accentPosition: accentPosition,
      pressed: pressed,
      actionMenuOpen: actionMenuOpen,
      layout: props.layout,
      accent: accent,
      spacingInset: props.spacingInset,
      focus: focus && focusTrigger === "keyboard" && !focusDescendent,
      clipStart: props.clipStart,
      clipEnd: props.clipEnd,
      clipRight: props.clipRight,
      clipLeft: props.clipLeft,
      clipBottom: props.clipBottom,
      clipTop: props.clipTop
    }) // If the tile is not clickable, add ref directly on Tile
    ,
    ref: !clickable ? ref : undefined,
    "mdn-text": "",
    "aria-describedby": !clickable ? props["aria-describedby"] : undefined,
    "aria-labelledby": !clickable ? props["aria-labelledby"] : undefined,
    "aria-disabled": !clickable && disabled ? true : undefined
  }, /*#__PURE__*/_react["default"].createElement("div", {
    "mdn-tile-children": ""
  }, props.children), props.actionBar ? /*#__PURE__*/_react["default"].createElement(_tileContext["default"].Provider, {
    value: context
  }, props.actionBar) : null);

  var onMouseDown = (0, _react.useCallback)(function (event) {
    // Determine if the mouse down action was directly on the tile (or
    // alternately if the pressed action was on a separate focuseable element
    // within the tile). If the former then we want to show the tile in a
    // pressed state, if the latter then we don't (we'll assume the focuseable
    // element being pressed within the tile has its own pressed state).
    var pressedDirectly = true;
    var node = event.target;

    while (pressedDirectly && node && !node.hasAttribute("mdn-tile")) {
      if ((0, _focus.canFocusNode)(node)) {
        pressedDirectly = false;
      } else {
        node = node.parentNode;
      }
    }

    setPressed(pressedDirectly);
  }, []);
  var onMouseUpOrLeave = (0, _react.useCallback)(function () {
    return setPressed(false);
  }, []); // If the tile is clickable and not disabled then wrap it in a Clickable
  // component for super-duper interactivity.

  return clickable ? /*#__PURE__*/_react["default"].createElement(_clickable["default"], (0, _extends2["default"])({}, props, focusProps, {
    tag: "div",
    "mdn-tile": "",
    "mdn-tile-hover": actionMenuOpen ? "" : undefined,
    onMouseDown: onMouseDown,
    onMouseUp: onMouseUpOrLeave,
    onMouseLeave: onMouseUpOrLeave // Add ref to clickable wrapper
    ,
    ref: ref
  }), tileElement) : tileElement;
});

Tile.displayName = "Tile";
Tile.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The contents of the tile. Anything is allowed, although interactive
   * elements should be avoided if possible when the tile itself is made
   * clickable by setting the `onClick` or `href` props.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * Use this to apply an accent bar to the event. Any CSS color value is acceptable.
   */
  accent: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(["success", "warning", "error", "theme", "neutral"]), _propTypes["default"].string]),

  /**
   * This determines the position of the accent bar applied via the `accent`
   * prop.
   */
  accentPosition: _propTypes["default"].oneOf(["top", "left", "right", "start", "end"]),

  /**
   * Pass a rendered `TileActionBar` element here.
   */
  actionBar: _propTypes["default"].node,

  /**
   * Set this to the id of the an element that describes the tile. See the
   * [MDN aria-describedby docs](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-describedby_attribute)
   * for details.
   */
  "aria-describedby": _propTypes["default"].string,

  /**
   * Set this to the id of the an element that labels the tile. See the
   * [MDN aria-labelledby docs](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-labelledby_attribute)
   * for details.
   */
  "aria-labelledby": _propTypes["default"].string,

  /**
   * Set to true to turn off the border and radius for the bottom of the tile. Useful
   * for distributed events that go beyond the boundaries of a calendar view.
   */
  clipBottom: _propTypes["default"].bool,

  /**
   * Set to true to turn off the border and radius for the end of the tile (right
   * in left-to-right contexts and left in right-to-left contexts). Useful for
   * distributed events that go beyond the boundaries of a calendar view.
   */
  clipEnd: _propTypes["default"].bool,

  /**
   * NOTE: This is deprecated, use `clipStart` instead.
   *
   * @deprecated 5.x
   */
  clipLeft: _propTypes["default"].bool,

  /**
   * NOTE: This is deprecated, use `clipEnd` instead.
   *
   * @deprecated 5.x
   */
  clipRight: _propTypes["default"].bool,

  /**
   * Set to true to turn off the border and radius for the start of the tile (left
   * in left-to-right contexts and right in right-to-left contexts). Useful for
   * distributed events that go beyond the boundaries of a calendar view.
   */
  clipStart: _propTypes["default"].bool,

  /**
   * Set to true to turn off the border and radius for the top of the tile. Useful
   * for distributed events that go beyond the boundaries of a calendar view.
   */
  clipTop: _propTypes["default"].bool,

  /**
   * Set this to true to mark the event as disabled. This will block clicks on
   * the tile and any actions in the tile's action bar.
   */
  disabled: _propTypes["default"].bool,

  /**
   * If a URL is provided here, the component will behave like a link.
   *
   * Note that you must either set this prop or the `onClick` prop (or both).
   */
  href: _propTypes["default"].string,

  /**
   * Manually set the size and position of the tile. This is useful for advanced
   * layouts that involve coordinating the position of multiple tiles. If the
   * top or left fields are set then the tile will be positioned absolutely.
   * Not all fields in the layout object are required.
   */
  layout: _propTypes["default"].shape({
    width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
    height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
    top: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
    left: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
  }),

  /**
   * The relationship of the linked URL to the current page. Only applicable if
   * `href` is set.
   *
   * See docs for the [a tag's rel attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-rel) for details.
   */
  rel: _propTypes["default"].string,

  /**
   * Apply padding to the component.
   *
   * CSS-style [1-to-4 value shorthand](https://developer.mozilla.org/en-US/docs/Web/CSS/Shorthand_properties)
   * is accepted (e.g. `"small medium"` for small padding on the top/bottom and
   * medium padding on the left/right).
   */
  spacingInset: _propTypes2["default"].spacing(4),

  /**
   * Determine where the linked URL is displayed. This is only applicable if
   * `href` is provided but `onClick` is not.
   *
   * IMPORTANT: If you set this prop to `"_blank"`, make sure to set `rel` to
   * `"noopener noreferrer"` to avoid performance and security issues.
   *
   * See docs for the [a tag's target attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-target) for details.
   */
  target: _propTypes["default"].string,

  /**
   * This will be triggered when the component is clicked. If the `href` prop is
   * set, that value will be passed as the first argument to this function.
   *
   * If this prop is used along with the `href` prop, the default link behavior
   * of the component will be disabled and the click handler will be responsible
   * for implementing the behavior of the component.
   *
   * These features make it easy to implement accessible client-side navigation.
   * If you have a client-side navigation function of the form `navigate(<url>)`, you
   * can integrate it into this component by setting a URL via `href` and then
   * passing `navigate` directly to this prop (i.e. `href={url} onClick={navigate}`).
   * See the [Routing and navigation guide](https://meridian.a2z.com/for-developers/guides/routing-and-navigation/?platform=react-web)
   * for details.
   *
   * Note that you must set either this prop or the `href` prop (or both).
   */
  onClick: _propTypes["default"].func
} : {};
Tile.defaultProps = {
  accentPosition: "left"
};
var _default = Tile;
exports["default"] = _default;